<template>
  <div
    id="addBadge"
    class="tab-pane "
    role="tabpanel"
  >
    <!-- .author -->
    <b-form-group
      id="input-group-1"
      :label="$t('blogs.author')"
      label-for="input-1"
    >
      <Select2
        id="input-1"
        v-model="newItem.author"
        :options="authorOptions"
      />
    </b-form-group>        <!-- .title -->
    <b-form-group
      id="input-group-2"
      :label="$t('blogs.title')"
      label-for="input-2"
    >
      <b-form-input
        id="input-2"
        v-model="newItem.title"
        type="text"
        :placeholder="$t('blogs.title')"
      />
    </b-form-group>
    <!-- .content -->
    <b-form-group
      id="input-group-3"
      :label="$t('blogs.content')"
      label-for="input-3"
    >
      <b-form-input
        id="input-3"
        v-model="newItem.content"
        type="text"
        :placeholder="$t('blogs.content')"
      />
    </b-form-group>
    <!-- .is_published -->
    <b-form-group
      id="input-group-4"
      :label="$t('blogs.is_published')"
      label-for="input-4"
    >
      <b-form-input
        id="input-4"
        v-model="newItem.is_published"
        type="text"
        :placeholder="$t('blogs.is_published')"
      />
    </b-form-group>
    <!-- .published_at -->
    <b-form-group
      id="input-group-5"
      :label="$t('blogs.published_at')"
      label-for="input-5"
    >
      <b-form-input
        id="input-5"
        v-model="newItem.published_at"
        type="text"
        :placeholder="$t('blogs.published_at')"
      />
    </b-form-group>
    <!-- .comments_approval -->
    <b-form-group
      id="input-group-6"
      :label="$t('blogs.comments_approval')"
      label-for="input-6"
    >
      <b-form-input
        id="input-6"
        v-model="newItem.comments_approval"
        type="text"
        :placeholder="$t('blogs.comments_approval')"
      />
    </b-form-group>
    <!-- .blog_type -->
    <b-form-group
      id="input-group-7"
      :label="$t('blogs.blog_type')"
      label-for="input-7"
    >
      <b-form-input
        id="input-7"
        v-model="newItem.blog_type"
        type="text"
        :placeholder="$t('blogs.blog_type')"
      />
    </b-form-group>
    <!-- .main_image -->
    <b-form-group
      id="input-group-8"
      :label="$t('blogs.main_image')"
      label-for="input-8"
    >
      <b-form-input
        id="input-8"
        v-model="newItem.main_image"
        type="text"
        :placeholder="$t('blogs.main_image')"
      />
    </b-form-group>
    <!-- .second_image -->
    <b-form-group
      id="input-group-9"
      :label="$t('blogs.second_image')"
      label-for="input-9"
    >
      <b-form-input
        id="input-9"
        v-model="newItem.second_image"
        type="text"
        :placeholder="$t('blogs.second_image')"
      />
    </b-form-group>
    <!-- .second_image_preview -->
    <b-form-group
      id="input-group-10"
      :label="$t('blogs.second_image_preview')"
      label-for="input-10"
    >
      <b-form-input
        id="input-10"
        v-model="newItem.second_image_preview"
        type="text"
        :placeholder="$t('blogs.second_image_preview')"
      />
    </b-form-group>

    <div class="form-group">
      <button
        type="button"
        class="btn btn-primary"
        @click="submit()"
      >
        <i class="fa fa-plus" /> {{ $t('site.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import Select2 from 'v-select2-component'
import Controller from '../../../../Controllers/BlogsController'
import config from '../../../../config/config'

const controller = new Controller()
export default {
  name: 'BlogsForm',
  components: {
    Select2,
  },
  props: ['newItem'],
  data() {
    return {
      file: {},
      
      author: [],

    }
  },
  methods: {
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      controller.From(this.newItem, 'FormData')
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },

  },

}
</script>
